import React from 'react';
import ReactDocumentTitle from 'react-document-title';
import { fg } from '@atlaskit/platform-feature-flags';
export var HubsDocumentTitle = function HubsDocumentTitle(_ref) {
  var title = _ref.title,
    shouldRenderDocumentTitle = _ref.shouldRenderDocumentTitle,
    children = _ref.children;
  if (!title || !shouldRenderDocumentTitle || !fg('platform_hubs_document_title_v2')) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(ReactDocumentTitle, {
    title: title
  }, children);
};